import Translations from "../../translations.json";

export type TranslationKey = keyof typeof Translations;

const INTL_LOCALE_MAP: Record<string, string> = {
  de: "de-DE",
  en: "en-US",
  es: "es-ES",
  fr: "fr-FR",
  ne: "ne-NP",
  ru: "ru-RU",
  tr: "tr-TR",
};

export function createTranslator(getLocale: () => string) {
  return (phraseKey: TranslationKey): string => {
    const locale = getLocale();
    const phrase = Translations[phraseKey];

    if (locale in phrase) {
      return (phrase as any)[locale];
    }

    return phrase.en;
  };
}

export function getIntlLocale(locale?: string): string {
  if (!locale) {
    return "en-US";
  }

  return INTL_LOCALE_MAP[locale] ?? locale;
}
